export const MIN_ZOOM_LEVEL = 14